module.exports = __webpack_public_path__ + "img/fastlovestudios.a091241b.gif";